import debounce from 'lodash.debounce'
import { useCallback, useState } from 'react'

type useIframeProps = {
  origin: string
  src: string
  title?: string
}

const useIframe = ({ origin, src, title }: useIframeProps) => {
  const [height, setHeight] = useState('100vh')

  const receiveMessage = useCallback(
    (event: MessageEvent) => {
      try {
        const expectedOrigin = new URL(origin).origin
        if (event.origin !== expectedOrigin) return
      } catch {
        if (event.origin !== origin.replace(/\/$/g, '')) return
      }

      const { height: iframeHeight } = event.data

      const debouncedHeightUpdate = debounce((iframeHeight) => {
        setHeight((prev) => {
          const newHeight = Math.ceil(Number(iframeHeight) + 50)
          const prevHeight = parseFloat(prev)

          if (Math.abs(Number(iframeHeight) - prevHeight) < 10) return prev
          return `${newHeight}px`
        })
      })

      if (iframeHeight) {
        debouncedHeightUpdate(iframeHeight)
      }
    },
    [origin]
  )

  return {
    receiveMessage,
    iframeAttributes: {
      src,
      style: {
        border: 'none',
        display: 'block',
        width: '100%',
        height,
        padding: 0,
        margin: 0
      },
      title
    }
  }
}

export default useIframe
